import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  clearButton: {
    position: "absolute",
    right: 0,
    top: "12px",
  },
  selectAllButton: {
    position: "absolute",
    right: "85px",
    top: "12px",
  },
}));

type Props = {
  state: any; // NOTE: Search.jsで定義されているstateに型情報がないため
  action: (e: any) => void;
};

/**
 * 全選択ボタンとクリアボタンを合わせたコンポーネント
 * @param props stateとその更新関数の組み合わせ
 */
const ButtonGroup: React.FC<Props> = (props) => {
  const { state, action } = props;
  const classes = useStyles();
  const select = () => action(state);
  const clear = () => action([]);

  return (
    <>
      <Button
        className={classes.selectAllButton}
        color="primary"
        variant="contained"
        onClick={select}
      >
        全選択
      </Button>
      <Button
        className={classes.clearButton}
        color="primary"
        variant="outlined"
        onClick={clear}
      >
        クリア
      </Button>
    </>
  );
};

export { ButtonGroup };
